// A trace-review finding's citations as (quote, message id) pairs, zipped
// before anything is dropped: the projection emits the two arrays
// index-aligned, and a clipped quote can be empty while its message id never
// is. The triage map and an opened session's findings both read them so.
export const NIL_ID = "00000000-0000-0000-0000-000000000000";

export function citationsOf(row) {
    const quotes = Array.isArray(row?.citation_quotes) ? row.citation_quotes : [];
    const ids = Array.isArray(row?.citation_message_ids) ? row.citation_message_ids : [];
    const out = [];
    for (let i = 0; i < Math.max(quotes.length, ids.length); i++) {
        const quote = typeof quotes[i] === "string" ? quotes[i] : "";
        const id = String(ids[i] ?? "").trim().toLowerCase();
        const messageId = id && id !== NIL_ID ? id : null;
        if (quote || messageId) out.push({ quote, messageId });
    }
    return out;
}
